//
// Copyright 2025 DXOS.org
//

import * as Schema from 'effect/Schema';

import * as SchemaAST from '@dxos/effect/SchemaAST';

const ForeignKey_ = Schema.Struct({
  /**
   * Name of the foreign database/system.
   * E.g., `github.com`.
   */
  source: Schema.String,

  /**
   * Id within the foreign database.
   */
  // TODO(wittjosiah): This annotation is currently used to ensure id field shows up in forms.
  // TODO(dmaretskyi): `false` is not a valid value for the annotation. Use a different annotation.
  id: Schema.String.annotate({ [SchemaAST.IdentifierAnnotationId]: 'false' }),
});

export type ForeignKey = Schema.Schema.Type<typeof ForeignKey_>;

/**
 * Reference to an object in a foreign database.
 */
// Annotated as `Codec`, not `Schema`: Effect 4's `Schema.Schema<T>` pins only `Type` and leaves the
// service channels `unknown`, which propagates into every struct embedding this and blocks the
// service-free decode APIs.
export const ForeignKey: Schema.Codec<ForeignKey> = ForeignKey_;
